import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { scrolledState } from "../store/atom";
import { useRecoilValue } from "recoil";

export default function Header() {
  const [isHoveringQMS, setIsHoveringQMS] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(false);
  const [submenuVisible, setSubmenuVisible] = useState(null);
  const isMainScrolled = useRecoilValue(scrolledState);
  const [isScrolled, setIsScrolled] = useState(false);

  const isMain = useLocation().pathname === "/";

  const menuItems = [
    {
      title: "회사소개",
      submenu: [
        { title: "대표이사 인사말", path: "/about?menu=대표이사 인사말" },
        { title: "연혁", path: "/about?menu=연혁" },
        { title: "조직도", path: "/about?menu=조직도" },
        { title: "오시는 길", path: "/about?menu=오시는 길" },
      ],
    },
    {
      title: "구성원",
      submenu: [
        { title: "전체보기", path: "/members?menu=전체보기" },
        { title: "본점", path: "/members?menu=본점" },
        { title: "구로분실", path: "/members?menu=구로분실" },
        { title: "강남분실", path: "/members?menu=강남분실" },
        { title: "광주지점", path: "/members?menu=광주지점" },
      ],
    },
    {
      title: "서비스",
      submenu: [
        { title: "회계감사", path: "/services?menu=회계감사" },
        { title: "세무자문", path: "/services?menu=세무자문" },
        { title: "재무자문", path: "/services?menu=재무자문" },
        { title: "경영자문", path: "/services?menu=경영자문" },
      ],
    },
    {
      title: "상담문의",
      submenu: [{ title: "온라인 상담 신청", path: "/consulting" }],
    },
  ];

  function ExternalLinkIcon() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="20"
        height="20"
        fill="currentColor"
        viewBox="0 0 30 30"
      >
        <path d="M 25.980469 2.9902344 A 1.0001 1.0001 0 0 0 25.869141 3 L 20 3 A 1.0001 1.0001 0 1 0 20 5 L 23.585938 5 L 13.292969 15.292969 A 1.0001 1.0001 0 1 0 14.707031 16.707031 L 25 6.4140625 L 25 10 A 1.0001 1.0001 0 1 0 27 10 L 27 4.1269531 A 1.0001 1.0001 0 0 0 25.980469 2.9902344 z M 6 7 C 4.9069372 7 4 7.9069372 4 9 L 4 24 C 4 25.093063 4.9069372 26 6 26 L 21 26 C 22.093063 26 23 25.093063 23 24 L 23 14 L 23 11.421875 L 21 13.421875 L 21 16 L 21 24 L 6 24 L 6 9 L 14 9 L 16 9 L 16.578125 9 L 18.578125 7 L 16 7 L 14 7 L 6 7 z"></path>
      </svg>
    );
  }

  const handleMouseEnter = (index) => {
    setSubmenuVisible(index);
    setIsHoveringQMS(false);
    setOpenSubmenu(true);
  };

  const handleMouseLeave = () => {
    setSubmenuVisible(null);
    setOpenSubmenu(false);
    setIsHoveringQMS(false);
  };

  const handleMouseEnterQMS = () => {
    setIsHoveringQMS(true);
    setSubmenuVisible(null);
  };

  const scrolled = isMainScrolled || isScrolled;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <header
        className={`header ${openSubmenu || isHoveringQMS ? "open" : ""} ${scrolled ? "scrolled" : ""
          } ${!isMain ? "main" : ""}`}
      >
        <div className={`header-bg ${openSubmenu ? "open" : ""} ${isHoveringQMS ? "open open-qms" : ""}`}></div>
        <div className="header-wrap">
          <div className="header-box">
            <Link
              className={`logo ${openSubmenu || isHoveringQMS ? "open" : ""} ${scrolled ? "scrolled" : ""
                } `}
              to="/"
            >
              <span>회계법인새시대</span>
            </Link>
            <nav>
              <ul className="main-menu" onMouseLeave={handleMouseLeave}>
                {menuItems.map((item, index) => (
                  <li key={index} onMouseEnter={() => handleMouseEnter(index)}>
                    <Link to={item.submenu[0].path}>{item.title}</Link>
                    <ul
                      className={`sub-menu ${openSubmenu && submenuVisible === index ? "open" : ""
                        }`}
                    >
                      {item.submenu.map((subItem, subIndex) => (
                        <li key={subIndex}>
                          <Link to={subItem.path}>{subItem.title}</Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
                <li onMouseEnter={handleMouseEnterQMS}>
                  <a
                    href="https://qms.ssdac.kr"
                    target="_blank"
                    style={{ display: "flex", alignItems: "center", width: "153px", justifyContent: "center" }} rel="noreferrer"
                  >
                    <span>새시대 QMS</span>
                    <span
                      style={{
                        marginLeft: "5px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <ExternalLinkIcon />
                    </span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
}
